import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    static targets = [
        "input", "confirm",
        "reqLength", "reqUpper", "reqNumber", "reqSpecial",
        "generatedBox", "generatedText",
    ]

    declare readonly inputTarget: HTMLInputElement
    declare readonly confirmTarget: HTMLInputElement
    declare readonly reqLengthTarget: HTMLElement
    declare readonly reqUpperTarget: HTMLElement
    declare readonly reqNumberTarget: HTMLElement
    declare readonly reqSpecialTarget: HTMLElement
    declare readonly generatedBoxTarget: HTMLElement
    declare readonly generatedTextTarget: HTMLInputElement

    validate(): void {
        const val = this.inputTarget.value
        this.mark(this.reqLengthTarget, val.length >= 10)
        this.mark(this.reqUpperTarget,  /[A-Z]/.test(val))
        this.mark(this.reqNumberTarget, /[0-9]/.test(val))
        this.mark(this.reqSpecialTarget, /[^A-Za-z0-9]/.test(val))
    }

    generate(): void {
        const upper   = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        const lower   = 'abcdefghijklmnopqrstuvwxyz'
        const digits  = '0123456789'
        const special = '!@#$%&*-_=+'
        const all     = upper + lower + digits + special

        // Garantiza al menos un carácter de cada grupo
        let pwd = upper[Math.floor(Math.random() * upper.length)]
                + lower[Math.floor(Math.random() * lower.length)]
                + digits[Math.floor(Math.random() * digits.length)]
                + special[Math.floor(Math.random() * special.length)]

        for (let i = 0; i < 9; i++) {
            pwd += all[Math.floor(Math.random() * all.length)]
        }

        pwd = pwd.split('').sort(() => Math.random() - 0.5).join('')

        this.inputTarget.value   = pwd
        this.confirmTarget.value = pwd

        // Mostrar la contraseña generada para que el usuario la pueda copiar
        this.generatedTextTarget.value = pwd
        this.generatedBoxTarget.classList.remove('d-none')

        this.validate()
    }

    copy(): void {
        const val = this.generatedTextTarget.value
        if (!val) return

        navigator.clipboard.writeText(val).then(() => {
            const btn = this.element.querySelector<HTMLElement>('[data-action*="copy"]')
            if (btn) {
                const original = btn.innerHTML
                btn.innerHTML = '<i class="bi bi-check-lg me-1"></i>Copiado'
                setTimeout(() => { btn.innerHTML = original }, 2000)
            }
        })
    }

    private mark(el: HTMLElement, ok: boolean): void {
        el.classList.toggle('text-success', ok)
        el.classList.toggle('text-danger',  !ok)
        const icon = el.querySelector('i')
        if (icon) {
            icon.className = ok
                ? 'bi bi-check-circle-fill me-1'
                : 'bi bi-x-circle-fill me-1'
        }
    }
}
